/**
 * What a press-and-hold on the grid can do to the range it selected, in one step — whether the range held
 * something or not:
 *   counter  put the officer on a counter, or a free-text duty (counter 0 with its text)
 *   officer  put an officer on this counter (the counter grid), in place of whoever was there
 *   break    a break the officer takes here — drawn "#"
 *   clear    nothing here: the officer is available but unassigned — drawn green
 *   unavailable  (counter grid) take these counters out of service for the range — drawn gray hatched
 */
/** An SOS officer who is not on the roster yet, made by the same action that puts them on the counter. */
export interface NewOfficerDraft {
  name: string;
  deployment: string;
}

export type CellAction =
  | { kind: 'counter'; counter: number; duty?: string }
  | { kind: 'officer'; officerId: string; newOfficer?: NewOfficerDraft }
  | { kind: 'break' }
  | { kind: 'clear' }
  | { kind: 'unavailable'; counters: number[] };

export type CellActionKind = CellAction['kind'];

/** How each action reads on its tab and its Save button, and the colour it is drawn in. */
export const CELL_ACTION_LOOK: Record<CellActionKind, { tab: string; save: string; busy: string; color: string }> = {
  counter: { tab: '# Counter', save: 'Save', busy: 'Saving…', color: '#2563eb' },
  officer: { tab: 'Officer', save: 'Save', busy: 'Saving…', color: '#2563eb' },
  break: { tab: '☕ Break', save: 'Set break', busy: 'Saving…', color: '#16a34a' },
  clear: { tab: '⌫ Clear', save: 'Clear', busy: 'Clearing…', color: '#dc2626' },
  unavailable: { tab: '🚫 Unavailable', save: 'Mark unavailable', busy: 'Saving…', color: '#475569' },
};
